import React from 'react';
import Button from './Button';
import '../styles/moreInfo.css';
import moreInfoImage from '../assets/img/moreInfo_img.svg';

function MoreInfo() {
    return (
        <div className='more-info-container'>
            <img src={moreInfoImage} alt="More Information" className='more-info-image'/>
            <div className='more-info-content'>
                <p className='more-info-title'>Interested ?</p>
                <p className='more-info-text'>We can discuss about your project.</p>
                <Button
                    label="Contact us"
                    bgColor={"#AD7B28"}
                    color={"white"}
                    borderColor={"none"}
                    path={"/contact"}
                />
            </div>
        </div>
    );
}

export default MoreInfo;